<header class="dialog-header">
  <h3 class="header-heading">{{ 'pages.user-subscriptions.payment-dialog.heading' | translate }}</h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<div class="dialog-content">

  <div class="row">

    <div class="payment-summary">
      <h3 class="content-heading">{{ 'pages.user-subscriptions.payment-dialog.heading-summary' | translate }}</h3>
      <div class="items">
        <div class="item" *ngFor="let item of data">
          <div class="info">
            <span class="name">{{ item.name }}</span>
            <span class="code">{{ item.code }}</span>
            <span class="dates" *ngIf="item.purposeStartDate && item.purposeEndDate">{{ item.purposeStartDate | shortDate }} - {{ item.purposeEndDate | shortDate }}</span>
          </div>
          <div class="currency">{{ item.cost | twoDecimal }} $</div>
        </div>
      </div>
      <div class="summary">
        <div class="subtotal">
          <span class="label">{{ 'pages.user-subscriptions.payment-dialog.subtotal' | translate }}</span>
          <span class="currency">{{ this.itemsSubtotal | twoDecimal }} $</span>
        </div>
        <div class="tax" *ngFor="let tax of taxes">
          <span class="label">{{ tax.name }}</span>
          <span class="curreny">{{ getSingleTaxAmount(tax.rate) | twoDecimal }} $</span>
        </div>
      </div>
      <div class="total">
        <span class="label">Total</span>
        <span class="currency">{{ this.itemsSubtotal + this.taxesTotal | twoDecimal }} $</span>
      </div>
    </div>
  
    <div *ngIf="!isFree" class="payment-information">
      <h3 class="content-heading">{{ 'pages.user-subscriptions.payment-dialog.heading-payment' | translate }}</h3>

      <app-form-select-user-cards
        class="payment-type-form"
        [placeholder]="'Choose a payment type'"
        [label]="'Payment Type'"
        [useOptionAll]="false"
        [options]="paymentOptions"
        [selected]="paymentOptions[0]"
      (selectChange)="handleSelectPaymentType($event)">
      </app-form-select-user-cards>

      <form id="payment-form" [formGroup]="form" [ngClass]="selectedPaymentType === paymentOptions[0] ? '' : 'hidden'">
        <input type="hidden"  name="payment_method_token" id="payment_method_token">
  
        <label for="full_name">{{ 'pages.user-subscriptions.payment-dialog.spreedly.name' | translate }}</label>
        <input class="large" type="text" id="full_name" name="cc-name" formControlName="fullName" autofill="cc-name" autocomplete="on">
  
        <label>{{ 'pages.user-subscriptions.payment-dialog.spreedly.card-number' | translate }}</label>
        <div id="spreedly-number" class="spreedly-iframe-field" name="cc-number" autofill="cc-number" autocomplete="on"></div>
  
        <label for="month">{{ 'pages.user-subscriptions.payment-dialog.spreedly.exp-date' | translate }}</label>
        <input class="small" type="text" id="month" name="month" maxlength="2" autocomplete="on" autofill="cc-exp-month" formControlName="month"> / 
        <input class="small" type="text" id="year" name="year" maxlength="4" autocomplete="on" autofill="cc-exp-year" formControlName="year">
  
        <label>{{ 'pages.user-subscriptions.payment-dialog.spreedly.cvv' | translate }}</label>
        <div id="spreedly-cvv" class="spreedly-iframe-field" name="cvc" autofill="cc-csc" autocomplete="on"></div>
      </form>

      <form id="in-person-form" [formGroup]="inPersonForm" [ngClass]="selectedPaymentType === paymentOptions[1] ? '' : 'hidden'">
        <label for="reference">Reference #</label>
        <input class="large" type="text" id="reference" name="reference" formControlName="reference">
      </form>
    </div>

  </div>

  <div class="row">
    <div class="errors">
      <p class="error" *ngFor="let error of errors">
        <span class="icon-close"></span> {{ error }}
      </p>
    </div>
  </div>
  
</div>

<footer class="dialog-footer">
  <button
    (click)="closeDialog()"
    class="bciti-inline-button back-button"
  >
    {{ 'pages.user-subscriptions.payment-dialog.cancel' | translate }}
  </button>
  <button
    id="submit-button"
    [disabled]="disableSubmit"
    [class.bciti-button--disabled]="disableSubmit"
    (click)="disableSubmit ? '' : submit()" 
    class="bciti-button bciti-button--blue next-button">
    <span *ngIf="!processingSubmit">{{ 'pages.user-subscriptions.payment-dialog.submit' | translate }}</span>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </button>
</footer>
